
<div *ngIf="card && isValid()" class="btn-track chip d-inline-block px-2 py-1" (click)="onFollowClick(card)">
    <div class="d-flex flex-row align-items-center">
        <img class="picto-medium" [src]="isFollow ? '../../../assets/images/231116/pictos/FollowOn.svg' : '../../../assets/images/231116/pictos/Follow.svg'" />
        <div class="typo-chip-follow px-2">{{ getChipText() }}</div>
    </div>
</div>